// YouTube RSS Feed를 사용한 동영상 가져오기 (API 키 불필요)
const CHANNEL_HANDLE = '@happy_dion'; // @happy_dion 채널 핸들

// 핸들로부터 채널 ID 가져오기 (개선된 버전)
async function getChannelIdFromHandle(handle) {
  const handleName = handle.replace('@', '');
  
  // 방법 1: RSS Feed URL 직접 사용 (핸들 기반)
  try {
    // YouTube는 핸들 기반 RSS도 지원합니다
    const rssUrl = `https://www.youtube.com/feeds/videos.xml?user=${handleName}`;
    const response = await fetch(`https://api.allorigins.win/get?url=${encodeURIComponent(rssUrl)}`);
    const data = await response.json();
    
    if (data.contents) {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data.contents, 'text/xml');
      const channelId = xmlDoc.querySelector('yt\\:channelId, channelId')?.textContent;
      if (channelId) {
        console.log('RSS Feed에서 채널 ID 찾음:', channelId);
        return channelId;
      }
    }
  } catch (error) {
    console.log('RSS Feed 방법 실패:', error.message);
  }
  
  // 방법 2: 채널 페이지에서 직접 추출
  try {
    const channelUrl = `https://www.youtube.com/@${handleName}`;
    const proxies = [
      'https://api.allorigins.win/raw?url=',
      'https://corsproxy.io/?',
    ];
    
    for (const proxy of proxies) {
      try {
        const response = await fetch(proxy + encodeURIComponent(channelUrl));
        const html = await response.text();
        
        // 여러 패턴으로 채널 ID 찾기
        const patterns = [
          /"channelId":"(UC[a-zA-Z0-9_-]{22})"/,
          /"externalId":"(UC[a-zA-Z0-9_-]{22})"/,
          /"ucid":"(UC[a-zA-Z0-9_-]{22})"/,
          /channel_id=(UC[a-zA-Z0-9_-]{22})/,
          /"browseId":"(UC[a-zA-Z0-9_-]{22})"/,
        ];
        
        for (const pattern of patterns) {
          const match = html.match(pattern);
          if (match && match[1] && match[1].startsWith('UC')) {
            console.log('채널 페이지에서 채널 ID 찾음:', match[1]);
            return match[1];
          }
        }
      } catch (error) {
        continue;
      }
    }
  } catch (error) {
    console.log('채널 페이지 방법 실패:', error.message);
  }
  
  return null;
}

// XML 파싱 헬퍼 함수
function parseXML(xmlText) {
  const parser = new DOMParser();
  return parser.parseFromString(xmlText, 'text/xml');
}

// RSS Feed에서 동영상 가져오기
export async function fetchRecentVideos(maxResults = 50) {
  console.log('동영상 가져오기 시작...');
  
  try {
    const handleName = CHANNEL_HANDLE.replace('@', '');
    
    // 방법 1: 핸들 기반 RSS Feed 직접 시도
    console.log('핸들 기반 RSS Feed 시도...');
    const handleRssUrl = `https://www.youtube.com/feeds/videos.xml?user=${handleName}`;
    let videos = await fetchFromRSSFeed(handleRssUrl, maxResults);
    
    if (videos.length > 0) {
      console.log(`핸들 RSS에서 ${videos.length}개 동영상 가져오기 성공`);
      return videos;
    }
    
    // 방법 2: 채널 ID 찾아서 RSS Feed 사용
    console.log('채널 ID 찾는 중...');
    const channelId = await getChannelIdFromHandle(CHANNEL_HANDLE);
    
    if (channelId) {
      console.log('채널 ID 찾음:', channelId);
      const channelRssUrl = `https://www.youtube.com/feeds/videos.xml?channel_id=${channelId}`;
      videos = await fetchFromRSSFeed(channelRssUrl, maxResults);
      
      if (videos.length > 0) {
        console.log(`채널 ID RSS에서 ${videos.length}개 동영상 가져오기 성공`);
        return videos;
      }
    }
    
    // 방법 3: 채널 페이지에서 직접 가져오기
    console.log('채널 페이지에서 직접 가져오기 시도...');
    videos = await fetchVideosFromChannelPage(CHANNEL_HANDLE, maxResults);
    
    if (videos.length > 0) {
      console.log(`채널 페이지에서 ${videos.length}개 동영상 가져오기 성공`);
      return videos;
    }
    
    console.log('모든 방법 실패');
    return [];
  } catch (error) {
    console.error('동영상 가져오기 에러:', error);
    return [];
  }
}

// RSS Feed에서 동영상 가져오기 헬퍼 함수
async function fetchFromRSSFeed(rssUrl, maxResults) {
  const proxies = [
    'https://api.allorigins.win/get?url=',
    'https://corsproxy.io/?',
    'https://api.codetabs.com/v1/proxy?quest=',
  ];
  
  for (const proxy of proxies) {
    try {
      const url = proxy + encodeURIComponent(rssUrl);
      console.log('RSS Feed 프록시 시도:', proxy);
      
      const response = await fetch(url);
      
      if (!response.ok) {
        console.log('RSS Feed 응답 실패:', response.status);
        continue;
      }
      
      let xmlText;
      if (proxy.includes('allorigins.win')) {
        const data = await response.json();
        xmlText = data.contents || data.content || '';
      } else {
        xmlText = await response.text();
      }
      
      if (!xmlText || xmlText.length < 100) {
        console.log('RSS Feed 데이터가 너무 짧음');
        continue;
      }
      
      const xmlDoc = parseXML(xmlText);
      
      // RSS Feed 파싱
      const entries = xmlDoc.querySelectorAll('entry');
      
      if (entries.length === 0) {
        console.log('RSS Feed에 entry가 없음');
        continue;
      }
      
      const videos = Array.from(entries).slice(0, maxResults).map(entry => {
        const videoId = entry.querySelector('yt\\:videoId')?.textContent || 
                       entry.querySelector('videoId')?.textContent ||
                       entry.querySelector('id')?.textContent?.split(':').pop() || '';
        const title = entry.querySelector('title')?.textContent || '';
        const description = entry.querySelector('media\\:description')?.textContent || 
                           entry.querySelector('description')?.textContent || '';
        const publishedAt = entry.querySelector('published')?.textContent || 
                           entry.querySelector('pubDate')?.textContent || '';
        const thumbnail = entry.querySelector('media\\:thumbnail')?.getAttribute('url') || 
                         `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
        
        return {
          id: videoId,
          title: title,
          description: description,
          thumbnail: thumbnail,
          publishedAt: publishedAt,
          viewCount: null,
          likeCount: null,
          url: `https://www.youtube.com/watch?v=${videoId}`
        };
      });
      
      if (videos.length > 0 && videos[0].id) {
        console.log(`RSS Feed 파싱 성공: ${videos.length}개`);
        return videos;
      }
    } catch (error) {
      console.log('RSS Feed 프록시 실패:', proxy, error.message);
      continue;
    }
  }
  
  return [];
}

// 채널 페이지에서 직접 동영상 정보 가져오기
async function fetchVideosFromChannelPage(handle, maxResults = 50) {
  try {
    const handleName = handle.replace('@', '');
    const channelUrl = `https://www.youtube.com/@${handleName}/videos`;
    
    // 여러 프록시 옵션 시도
    const proxies = [
      'https://api.allorigins.win/raw?url=',
      'https://corsproxy.io/?',
      'https://api.codetabs.com/v1/proxy?quest=',
      'https://cors-anywhere.herokuapp.com/',
    ];
    
    let html = '';
    let success = false;
    
    for (const proxy of proxies) {
      try {
        const url = proxy + encodeURIComponent(channelUrl);
        console.log('프록시 시도:', proxy || '직접 접근');
        
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'text/html',
          },
        });
        
        if (response.ok) {
          html = await response.text();
          success = true;
          console.log('프록시 성공:', proxy || '직접 접근');
          break;
        }
      } catch (error) {
        console.log('프록시 실패:', proxy || '직접 접근', error.message);
        continue;
      }
    }
    
    if (!success || !html) {
      console.error('모든 프록시 실패');
      return [];
    }
    
    // YouTube 페이지에서 동영상 정보 추출 (여러 패턴 시도)
    const videoIdPatterns = [
      /"videoId":"([^"]{11})"/g,
      /"videoId"\s*:\s*"([^"]{11})"/g,
      /watch\?v=([a-zA-Z0-9_-]{11})/g,
    ];
    
    const titlePatterns = [
      /"title":{"runs":\[{"text":"([^"]+)"}/g,
      /"title":"([^"]+)"/g,
      /"simpleText":"([^"]+)"/g,
    ];
    
    let videoIds = [];
    let titles = [];
    
    // videoId 추출
    for (const pattern of videoIdPatterns) {
      const matches = [...html.matchAll(pattern)];
      if (matches.length > 0) {
        videoIds = matches.map(m => m[1]).filter(id => id.length === 11);
        // 중복 제거
        videoIds = [...new Set(videoIds)];
        if (videoIds.length > 0) break;
      }
    }
    
    // title 추출
    for (const pattern of titlePatterns) {
      const matches = [...html.matchAll(pattern)];
      if (matches.length > 0) {
        titles = matches.map(m => m[1]);
        if (titles.length > 0) break;
      }
    }
    
    // publishedTime 추출
    const publishedTimeRegex = /"publishedTimeText":{"simpleText":"([^"]+)"}/g;
    const publishedTimes = [...html.matchAll(publishedTimeRegex)].map(m => m[1]);
    
    // description 추출 시도
    const descriptionRegex = /"description":{"simpleText":"([^"]+)"}/g;
    const descriptions = [...html.matchAll(descriptionRegex)].map(m => m[1]);
    
    console.log(`동영상 ${videoIds.length}개 발견`);
    
    const videos = videoIds.slice(0, maxResults).map((videoId, index) => {
      const title = titles[index] || `동영상 ${index + 1}`;
      const description = descriptions[index] || '';
      const publishedTime = publishedTimes[index] || '';
      
      return {
        id: videoId,
        title: title,
        description: description,
        thumbnail: `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
        publishedAt: publishedTime ? new Date().toISOString() : new Date().toISOString(),
        viewCount: null,
        likeCount: null,
        url: `https://www.youtube.com/watch?v=${videoId}`
      };
    });
    
    return videos;
  } catch (error) {
    console.error('채널 페이지에서 동영상 가져오기 실패:', error);
    return [];
  }
}

// 동영상을 필터링 (여행지 포함 여부)
export function filterVideosByKeyword(videos, keyword, include = true) {
  return videos.filter(video => {
    const hasKeyword = video.description.toLowerCase().includes(keyword.toLowerCase()) ||
                      video.title.toLowerCase().includes(keyword.toLowerCase());
    return include ? hasKeyword : !hasKeyword;
  });
}

// 날짜 포맷팅
export function formatDate(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}.${month}.${day}`;
}

// 숫자 포맷팅 (조회수, 좋아요)
export function formatNumber(num) {
  const number = parseInt(num);
  if (number >= 1000000) {
    return (number / 1000000).toFixed(1) + 'M';
  } else if (number >= 1000) {
    return (number / 1000).toFixed(1) + 'K';
  }
  return number.toString();
}

